
































import { Advertisement } from "@/interfaces/advertisement";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  data() {
    return {
      active: false,
      req: {
        note: ""
      }
    };
  },
  methods: {
    async exec(cb: () => void) {
      if (!this.advertisement) {
        return;
      }
      await this.$store.dispatch("post", [
        this.advertisement["@id"] + "/contact",
        this.req
      ]);
      this.$emit("success");
      cb();
    }
  }
});
